const reactQueryConfig = {
  refetchOnWindowFocus: false,
};

export default reactQueryConfig;
